import axios from "axios";

const REST_API_BASE_URL = 'http://localhost:8080/webnet-hms/api/designation';

export const AddDesignationSer = (data) => {
  return axios.post(REST_API_BASE_URL, data, {
    headers: {
      'Content-Type': 'application/json' // Ensure the request is sent as JSON
    }
  });
};

